import "../../utilities/globals/index.js";
import { useState, useRef, useEffect } from 'react';
import { equal } from '@wry/equality';
import { DocumentType, verifyDocumentType } from "../parser/index.js";
import { useApolloClient } from "./useApolloClient.js";
export function useSubscription(subscription, options) {
  var client = useApolloClient(options === null || options === void 0 ? void 0 : options.client);
  verifyDocumentType(subscription, DocumentType.Subscription);

  var _a = useState({
    loading: !(options === null || options === void 0 ? void 0 : options.skip),
    error: void 0,
    data: void 0,
    variables: options === null || options === void 0 ? void 0 : options.variables
  }),
      result = _a[0],
      setResult = _a[1];

  var _b = useState(function () {
    if (options === null || options === void 0 ? void 0 : options.skip) {
      return null;
    }

    return client.subscribe({
      query: subscription,
      variables: options === null || options === void 0 ? void 0 : options.variables,
      fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
      context: options === null || options === void 0 ? void 0 : options.context
    });
  }),
      observable = _b[0],
      setObservable = _b[1];

  var ref = useRef({
    client: client,
    subscription: subscription,
    options: options
  });
  useEffect(function () {
    var _a, _b, _c, _d;

    var shouldResubscribe = options === null || options === void 0 ? void 0 : options.shouldResubscribe;

    if (typeof shouldResubscribe === 'function') {
      shouldResubscribe = !!shouldResubscribe(options);
    }

    if (options === null || options === void 0 ? void 0 : options.skip) {
      if (!(options === null || options === void 0 ? void 0 : options.skip) !== !((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.skip)) {
        setResult({
          loading: false,
          data: void 0,
          error: void 0,
          variables: options === null || options === void 0 ? void 0 : options.variables
        });
        setObservable(null);
      }
    } else if (shouldResubscribe !== false && (client !== ref.current.client || subscription !== ref.current.subscription || (options === null || options === void 0 ? void 0 : options.fetchPolicy) !== ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || !(options === null || options === void 0 ? void 0 : options.skip) !== !((_c = ref.current.options) === null || _c === void 0 ? void 0 : _c.skip) || !equal(options === null || options === void 0 ? void 0 : options.variables, (_d = ref.current.options) === null || _d === void 0 ? void 0 : _d.variables))) {
      setResult({
        loading: true,
        data: void 0,
        error: void 0,
        variables: options === null || options === void 0 ? void 0 : options.variables
      });
      setObservable(client.subscribe({
        query: subscription,
        variables: options === null || options === void 0 ? void 0 : options.variables,
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        context: options === null || options === void 0 ? void 0 : options.context
      }));
    }

    Object.assign(ref.current, {
      client: client,
      subscription: subscription,
      options: options
    });
  }, [client, subscription, options]);
  useEffect(function () {
    if (!observable) {
      return;
    }

    var subscription = observable.subscribe({
      next: function next(fetchResult) {
        var _a, _b;

        var result = {
          loading: false,
          data: fetchResult.data,
          error: void 0,
          variables: options === null || options === void 0 ? void 0 : options.variables
        };
        setResult(result);
        (_b = (_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onSubscriptionData) === null || _b === void 0 ? void 0 : _b.call(_a, {
          client: client,
          subscriptionData: result
        });
      },
      error: function error(_error) {
        setResult({
          loading: false,
          data: void 0,
          error: _error,
          variables: options === null || options === void 0 ? void 0 : options.variables
        });
      },
      complete: function complete() {
        var _a, _b;

        (_b = (_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onSubscriptionComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
      }
    });
    return function () {
      subscription.unsubscribe();
    };
  }, [observable]);
  return result;
}